import React from 'react'
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { getTypeColor, getTypeDarkColor } from '../../../../../constants/colors';

export default function SearchButton({ onClick, type }) {
  const colors = getTypeColor(type);
  const hoverColors = getTypeDarkColor(type);
  return (
    <Button
      variant="contained"
      aria-label="選択した条件で検索"
      onClick={onClick}
      sx={{
        borderRadius: "999px",
        px: 15,
        py: 2,
        fontSize: "16px",
        bgcolor: colors,
        "&.MuiButton-contained:hover": {
          backgroundColor: hoverColors,
        },
      }}
    >
      この条件で探す
    </Button>
  );
}

SearchButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
};
